import React, { type FC } from 'react';
import cn from 'classnames';

import { Button } from '@lt/components';
import PlaneIcon from '@lt/components/icons-react/rebrand/Plane';
import { i18n, useTranslation } from '@lt/localization';
import { LT_PHONE_NUMBER } from 'src/constants/common';
import { pluralizeOptions } from 'src/utils/pluralizeUtils';
import { pluralize } from 'src/utils/stringUtils';
import { scrollToFlights } from 'checkout/utils/globalUtils';
import PackageInfoItem from '../components/PackageInfoItem';

import type { PropsFromRedux } from '.';
import styles from './packageFlightInfo.module.css';

const FETCHING_TEXT = i18n.t('checkout.packageInfo.flight.update');
const makeFlightOptionsLabel = (flightsOptionsCount) =>
  `${i18n.t('checkout.packageInfo.flight.ticket')}. ${pluralize(
    flightsOptionsCount,
    [
      i18n.t('checkout.packageInfo.flight.access', { count: 1 }),
      i18n.t('checkout.packageInfo.flight.access', { count: 2 }),
      i18n.t('checkout.packageInfo.flight.access', { count: 2 }),
    ],
  )}
  ${flightsOptionsCount} ${pluralizeOptions(flightsOptionsCount)}`;

const PackageFlightInfo: FC<PropsFromRedux & { isArchived: boolean }> = ({
  flightsOptionsCount = 0,
  fetching = false,
  isManualPackage = false,
  isMobile = false,
  isArchived,
}) => {
  const { t } = useTranslation();
  const hasError = (!flightsOptionsCount && !fetching) || isManualPackage;
  const hasFlights = flightsOptionsCount > 0;
  let text = '';
  if (!isManualPackage) {
    text = hasFlights
      ? makeFlightOptionsLabel(flightsOptionsCount)
      : `${t('checkout.packageInfo.flight.noInfo')} ${LT_PHONE_NUMBER}`;
  }
  const showGoToFlightsBtn = !fetching && hasFlights && !isMobile;
  return !isArchived || (isArchived && hasFlights) ? (
    <PackageInfoItem icon={<PlaneIcon height={16} />} hasError={hasError}>
      <>
        <p className={styles.text}>{fetching ? FETCHING_TEXT : text}</p>
        {isManualPackage ? (
          <>
            <p className={styles.text}>
              {t('checkout.packageInfo.flight.noInclude')}
            </p>
            <p className={styles.text}>
              {t('checkout.packageInfo.flight.selectNo')}
            </p>
          </>
        ) : (
          showGoToFlightsBtn && (
            <Button
              className={cn(styles.text, styles.link)}
              type="button"
              functional
              onClick={scrollToFlights}
            >
              {t('checkout.packageInfo.flight.select')}
            </Button>
          )
        )}
      </>
    </PackageInfoItem>
  ) : null;
};

export default PackageFlightInfo;
